import { backgroundTransitionOnClick, IconFont, pointer } from '@byecode/ui'
import styled from 'styled-components'

export const Item = styled.div<{ isHover?: boolean }>`
    padding: 8px 0;
    padding-right: 16px;
    width: 100%;
    gap: 4px;
    min-height: 36px;
    /* border-radius: 4px; */
    ${pointer}
    ${({ isHover }) => isHover && backgroundTransitionOnClick}
`

export const Wrapper = styled.div<{ isHover?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
    /* border-radius: 4px; */
    ${pointer}
    ${({ isHover }) => isHover && backgroundTransitionOnClick}
`

export const Icon = styled(IconFont)<{ COLOR?: string }>`
    font-size: 16px;
    color: ${({ color }) => color ?? 'var(--color-gray-400)'};
`
